import React, { useState } from 'react';
import { AppBar, Toolbar, Typography, IconButton, Menu, MenuItem, Box, useMediaQuery } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import { Link } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';

function NavBar() {
    const [anchorEl, setAnchorEl] = useState(null);
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('md')); // スマホ用の判定

    const handleMenuOpen = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleMenuClose = () => {
        setAnchorEl(null);
    };

    const menuItems = [
        { name: 'Research', path: '/research' },
        { name: 'Publications', path: '/publications' },
        { name: 'Education', path: '/education' },
        { name: 'Admissions', path: '/admissions' },
        { name: 'Other Info', path: '/other-info' },
    ];

    return (
        <AppBar position="static" sx={{ backgroundColor: '#1976d2' }}>
            <Toolbar>
                <Typography variant="h6" component={Link} to="/" sx={{ flexGrow: 1, textDecoration: 'none', color: 'white' }}>
                    Lab Website
                </Typography>
                {isMobile ? (
                    <>
                        <IconButton color="inherit" edge="end" onClick={handleMenuOpen}>
                            <MenuIcon />
                        </IconButton>
                        <Menu
                            anchorEl={anchorEl}
                            open={Boolean(anchorEl)}
                            onClose={handleMenuClose}
                            PaperProps={{
                                style: {
                                    width: '200px',
                                },
                            }}
                        >
                            {menuItems.map((item) => (
                                <MenuItem
                                    key={item.name}
                                    component={Link}
                                    to={item.path}
                                    onClick={handleMenuClose}
                                >
                                    {item.name}
                                </MenuItem>
                            ))}
                        </Menu>
                    </>
                ) : (
                    <Box sx={{ display: 'flex', gap: '20px' }}>
                        {menuItems.map((item) => (
                            <Typography
                                key={item.name}
                                variant="button"
                                component={Link}
                                to={item.path}
                                sx={{ textDecoration: 'none', color: 'white', fontSize: '1rem' }}
                            >
                                {item.name}
                            </Typography>
                        ))}
                    </Box>
                )}
            </Toolbar>
        </AppBar>
    );
}

export default NavBar;
